import { axiosInstance } from './axiosConfig';

const URI = '/admsect';

export const getAdmsect = async () => {
  const response = await axiosInstance.get(`${URI}`);
  return response.data?.data;
};
